// extracted by mini-css-extract-plugin
export default {"contentContainer":"StudentLessonsCard_contentContainer__hsWLO"};